<template>
  <div class="business-evaluation">
    <div class="business-evaluation.header">
      <!-- <el-button
        type="primary"
        class="exportOut"
        icon="el-icon-download"
        @click="exportOut"
      >导出</el-button> -->
      <el-popover placement="bottom" width="300" v-model="visible">
        <el-date-picker
          style="width:100%"
          v-model="times"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <div style="text-align: right; margin-top: 10px">
          <el-button
            size="mini"
            type="text"
            @click="
              () => {
                visible = false;
                times = null;
              }
            "
          >
            取消
          </el-button>
          <el-button type="primary" size="mini" @click="exportOut">确定</el-button>
        </div>
        <!-- <el-button class="exportOut" style="margin-left:10px;" slot="reference" type="primary" icon="el-icon-download">导出</el-button> -->
      </el-popover>
      <el-input
        placeholder="请输入成果名称"
        v-model="searchValue"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <label style="margin-right:10px;line-height:40px;min-width:60px;">审核状态:</label>
      <el-select v-model="statusVal" placeholder="请选择" @change="search">
        <el-option :value="[]" label="全部"></el-option>
        <el-option :value="[0]" label="已申请"></el-option>
        <el-option :value="[1]" label="签订委托合同"></el-option>
        <el-option :value="[2, 4]" label="准备材料"></el-option>
        <el-option :value="[6]" label="补充材料 "></el-option>
        <el-option :value="[5, 7]" label="专家评审"></el-option>
        <el-option :value="[8]" label="编写报告"></el-option>
        <el-option :value="[9]" label="已完成"></el-option>
      </el-select>
      <label style="margin-right: 10px; line-height: 40px; min-width: 60px;margin-left: 10px;">
        申请来源:
      </label>
      <el-select
        style="width: 300px"
        v-model="srelease"
        clearable
        placeholder="请选择申请来源"
        @change="resourceChange"
      >
        <el-option label="大市场平台" :value="2" />
        <el-option label="成果交易平台" :value="3" />
      </el-select>
    </div>
    <Table
      :table="table"
      :url="url"
      @editEvent="editEvent"
      @checkEvent="checkEvent"
      @showRate="showRate"
      ref="children"
      :tableParams="tableParams"
    ></Table>
    <!-- <el-dialog title="详情"  :visible.sync="dialogCheck" :show-close="false" :modal-append-to-body="false" width="800px" center :close-on-click-modal="false">
				<el-form ref="form" :model="form" label-width="80px" >
					  <el-form-item label="成果名称">
						 <el-input v-model="form.gain_name" disabled></el-input>
					  </el-form-item>
					  <el-form-item label="成果类别">
					  	<el-input v-model="form.completed_by" disabled></el-input>
					  </el-form-item>
					  <el-form-item label="联系姓名">
					  		<el-input v-model="form.name" disabled></el-input>
					  </el-form-item>
					  <div style="display: flex;">
					  	<el-form-item label="联系方式">
					  		<el-input v-model="form.phone" disabled></el-input>
					  	</el-form-item>
					  	<el-form-item  prop="phone">
					  		<el-input v-model="form.phone" disabled></el-input>
					  	</el-form-item>
					  </div>
					 <el-form-item label="电子邮箱">
					  		<el-input v-model="form.email" disabled></el-input>
					  </el-form-item>
					  <el-form-item label="微信/QQ">
					  	  <el-input v-model="form.chat_qq" disabled></el-input>
					 </el-form-item>
					 <el-form-item label="成果简介">
					 	<editor v-model="form.remark" :upload-url="uploadURL" :img-show-url="imgUrl" disabled></editor>
					 </el-form-item>
					 <el-form-item>
		                 <el-button @click="dialogCheck = false">关 闭</el-button>
		                </el-form-item>
				  </el-form>
			</el-dialog> -->

    <!-- 详情 -->
    <evaluationDetailDialog
      :detailDialog="dialogCheck"
      :checkForm="form"
      @checkClose="detailClose"
    />

    <!-- 审核材料 -->
    <auditMaterial
      :auditMaterialDialog="auditMaterialDialog"
      :id="id"
      @auditClose="auditClose"
      @opinionShow="opinionShow"
    />

    <!-- 审核流程弹窗 -->
    <el-dialog
      title="科技成果标准化评价"
      :visible.sync="dialogFormVisible"
      :show-close="true"
      :modal-append-to-body="false"
      width="60%"
      center
      @close="close"
      :close-on-click-modal="false"
    >
      <div class="business-evaluation.step">
        <el-steps :active="activeStep" finish-status="success" simple>
          <el-step title="受理"></el-step>
          <el-step title="签订委托合同"></el-step>
          <el-step title="审核材料"></el-step>
          <el-step title="专家评审"></el-step>
          <el-step title="出具评价报告"></el-step>
        </el-steps>
      </div>
      <div class="business-evaluation.dialog">
        <div v-show="activeStep == 0">
          <p>您是否对该成果已经完成了受理？</p>
          <el-radio-group
            v-model="accept"
            size="small"
            v-if="applicationRecordId === null || applicationRecordId === ''"
          >
            <el-radio :label="1" border>已完成</el-radio>
          </el-radio-group>
          <el-button
            v-if="applicationRecordId != null && applicationRecordId != ''"
            type="primary"
            @click="handleDownLoad"
          >
            下载简易报告
          </el-button>
        </div>
        <div v-if="activeStep == 1">
          <el-upload
            class="upload-demo"
            :action="this.uploadURL"
            style="text-align: left;"
            :before-upload="beforeAvatarUpload"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'commissionContractSrc')"
            :file-list="commissionContractSrc"
            :on-success="
              (response, file, fileList) =>
                handleAvatarSuccess(response, file, fileList, 'commissionContractSrc')
            "
            list-type="picture"
          >
            <el-button size="small" type="primary">上传委托合同</el-button>
          </el-upload>
        </div>
        <div v-if="activeStep == 2">
          <p>您是否对该成果已经完成了审核？</p>
          <el-radio-group v-model="verify" size="small" @change="verifyChange">
            <el-radio :label="1" border>已完成</el-radio>
          </el-radio-group>
        </div>
        <div v-show="activeStep == 3">
          <el-upload
            class="upload-demo"
            :action="this.uploadURL"
            style="text-align: left;"
            :before-upload="beforeAvatarUpload"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'specialistReviewSrc')"
            :file-list="specialistReviewSrc"
            :on-success="
              (response, file, fileList) =>
                handleAvatarSuccess(response, file, fileList, 'specialistReviewSrc')
            "
            list-type="picture"
          >
            <el-button size="small" type="primary">上传附件材料</el-button>
          </el-upload>
        </div>

        <div v-if="activeStep == 4">
          <el-upload
            class="upload-demo"
            :action="this.uploadURL"
            style="text-align: left;"
            :before-upload="beforeAvatarUploadLimit"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'examinationResultsSrc')"
            :limit="1"
            :file-list="examinationResultsSrc"
            :on-success="
              (response, file, fileList) =>
                handleAvatarSuccess(response, file, fileList, 'examinationResultsSrc')
            "
            list-type="picture"
          >
            <el-button size="small" type="primary">上传评价报告</el-button>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="preEvent">{{activeStep == 0 ? '取 消':'上一步'}}</el-button> -->
        <el-button v-show="activeStep !== 5" @click="preEvent">取 消</el-button>
        <el-button v-show="activeStep !== 5" type="primary" @click="nextEvent">下一步</el-button>
        <el-button v-show="activeStep === 5" type="primary" @click="preEvent">已完成</el-button>
      </span>
    </el-dialog>

    <!-- 审核意见弹窗 -->
    <el-dialog
      :title="auditType === 5 ? '通过' : '退回'"
      :visible.sync="dialogOpinionVisible"
      :show-close="false"
      :modal-append-to-body="false"
      width="60%"
      center
      @close="closeOpinion"
      :close-on-click-modal="false"
    >
      <div slot="title" class="header-title">
        <div>{{ auditType === 5 ? '通过' : '退回' }}</div>
        <div @click="closeOpinion"><i class="el-icon-circle-close"></i></div>
      </div>
      <div class="apply-form" data-aos="fade-up" data-aos-once="true">
        <el-form ref="form" :model="auditForm" :rules="auditRules" style="margin-top: 20px">
          <el-row :gutter="160">
            <el-col :span="24">
              <el-form-item
                :label="auditType === 5 ? '补充意见：' : '退回原因：'"
                prop="returnComments"
              >
                <el-input
                  v-model="auditForm.returnComments"
                  :placeholder="auditType === 5 ? '请输入补充意见' : '请输入退回原因'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附件：" prop="auditFileList">
                <el-upload
                  class="upload-demo"
                  :action="this.uploadURL"
                  style="text-align: left;"
                  :before-upload="beforeAvatarUpload"
                  :on-remove="(file, fileList) => handleRemove(file, fileList, 'auditFileList')"
                  :file-list="auditFileList"
                  :on-success="
                    (response, file, fileList) =>
                      handleAvatarSuccess(response, file, fileList, 'auditFileList')
                  "
                  list-type="picture"
                >
                  <el-button size="small" type="primary">上传附件材料</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeOpinion" type="info">取 消</el-button>
        <el-button type="primary" @click="confirmAudit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 办件评价 -->
    <el-dialog
      custom-class="evaluation_dialog"
      title="办件评价"
      :visible.sync="dialogEvaluation"
      :show-close="false"
      :modal-append-to-body="false"
      width="800px"
      center
      :close-on-click-modal="false"
    >
      <div slot="title" class="header-title">
        办件评价
      </div>
      <!-- <el-form ref="evaluationForm" :model="evaluationForm" label-width="80px" :rules="rules">
        <el-form-item label="办结满意度" prop="gain_name">
          <el-rate v-model="evaluationForm.satisfaction"></el-rate>
        </el-form-item>
        <el-form-item label="评价内容" prop="gain_name">
          <el-input type="textarea" v-model="evaluationForm.appraiseContent"></el-input>
        </el-form-item>
      </el-form> -->
      <div class="evaluation_dialog_top">
        <div class="satisfaction">办结满意度</div>
        <el-rate v-model="satisfaction" disabled></el-rate>
      </div>

      <div class="evaluation_dialog_content">
        <div>评价内容：</div>
        <div class="content">
          <el-input
            type="textarea"
            v-model="appraiseContent"
            placeholder="为了下次给您更好的服务，请留下宝贵的意见吧，对您和我们都很重要哦~"
            disabled
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEvaluation = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { saveAs } from 'file-saver';
import JSZipUtils from 'jszip-utils';
import PizZip from 'pizzip';
import docxtemplater from 'docxtemplater';
import dateformat from '../../../../utils/dateformat';
import evaluationDetailDialog from './evaluationDetailDialog.vue';
import auditMaterial from './auditMaterial.vue';
import Table from './evaluationTable.vue';
import editor from '../../../components/tinymce-editor/tinymce-editor';
export default {
  components: {
    Table,
    editor,
    evaluationDetailDialog,
    auditMaterial
  },
  data() {
    return {
      isMarket: 0,
      isAchievement: 0,
      srelease: '',
      is_market: 1,
      dialogEvaluation: false,
      dialogOpinionVisible: false,
      auditMaterialDialog: false,
      applicationRecordId: '',
      visible: false,
      times: '',
      dialogCheck: false,
      satisfaction: 0,
      appraiseContent: '',
      table: {
        title: '科技成果评价',
        columns: [
          { prop: 'achievementName', label: '成果名称' },
          { prop: 'achievementType', label: '成果类型', type: 'achievement_type' },
          { prop: 'contactName', label: '联系姓名' },
          { prop: 'contactInformation', label: '联系方式' },
          { prop: 'createTime', label: '申请时间' },
          {
            prop: 'isMarket',
            label: '申请来源',
            type: 'resource'
          },
          {
            prop: 'status',
            label: '状态',
            type: 'status'
          },
          {
            prop: 'satisfaction',
            label: '评价',
            type: 'satisfaction'
          }
        ],
        hasBtn: true,
        hasSelect: false,
        btns: [
          { name: '查看', event: 'checkEvent', type: 'primary' },
          {
            name: '编辑',
            event: 'editEvent',
            type: 'success'
          }
        ]
      },
      url: `${urlConfig.devUrl}apij2/admin-api/voucher/achievement-appraise/page`,
      activeStep: 0,
      searchValue: '',
      dialogFormVisible: false,
      one: 1,
      commissionContractSrc: [],
      three: 1,
      specialistReviewSrc: [],
      examinationResultsSrc: [],
      id: 0,
      steps: [
        'preliminary_examination',
        'commission_contract_src',
        'preliminary_src',
        'second_examination',
        'examination_results_src'
      ],
      status: '',
      statusVal: [],
      form: {
        gain_name: '',
        completed_by: '',
        name: '',
        area_str: '',
        phone: '',
        email: '',
        chat_qq: '',
        remark: '',
        is_market: 1,
        is_achievement: 1
      },
      tableParams: {
        userId: 0
      },
      accept: 1, // 受理
      verify: 0, // 审核
      auditType: 0,
      auditForm: {
        returnComments: '', //	审批时意见
        approvalMaterialsSrc: '' //	审批附件
      },
      auditFileList: [],
      materialId: 0,
      auditRules: {}
    };
  },
  created() {
    console.log(JSON.parse(Cookies.get('userInfo')).id);
    this.tableParams.userId = JSON.parse(Cookies.get('userInfo')).id;
  },
  methods: {
    resourceChange() {
      if (!this.srelease) {
        this.isMarket = 2;
        this.isAchievement = 2;
      } else {
        if (this.srelease === 1) {
          this.isMarket = 1;
          this.isAchievement = 1;
        } else if (this.srelease === 2) {
          this.isMarket = 1;
        } else {
          this.isAchievement = 1;
        }
      }
      this.search();
    },
    showRate(id) {
      this.getRate(id);
    },
    getRate(id) {
      this.http
        .get(
          `${urlConfig.devUrl}apij2/admin-api/voucher/achievement-appraise-satisfaction/get?achievementAppraiseId=${id}`
        )
        .then(res => {
          if (res.code == 0) {
            this.satisfaction = res.data.satisfaction;
            this.appraiseContent = res.data.appraiseContent;
            this.dialogEvaluation = true;
          }
        });
    },
    closeOpinion() {
      this.dialogOpinionVisible = false;
    },
    opinionShow(type, materialId) {
      this.dialogOpinionVisible = true;
      this.auditType = type;
      this.materialId = materialId;
      if (type === 5) {
        this.auditForm.returnComments = '通过';
        this.auditRules = {};
        this.$refs.form.clearValidate();
      } else {
        this.auditForm.returnComments = '';
        this.auditRules = {
          returnComments: [
            {
              required: true,
              message: '请输入退回原因',
              trigger: 'blur'
            }
          ]
        };
      }
    },
    confirmAudit() {
      let obj = this.auditForm;
      obj.approvalMaterialsSrc = JSON.stringify(this.auditFileList);
      obj.id = this.materialId;
      obj.achievementAppraiseId = this.id;

      this.$refs.form.validate(valid => {
        if (valid) {
          this.http
            .post(
              `${urlConfig.devUrl}apij2/admin-api/voucher/achievement-appraise-raw-materials/update`,
              obj
            )
            .then(res => {
              if (res.code == 0 && res.data) {
                this.changeStatus();
              }
            });
        } else {
          return false;
        }
      });
    },
    // 改变申请状态
    changeStatus() {
      let obj = {
        id: this.id,
        status: this.auditType
      };
      this.http
        .put(`${urlConfig.devUrl}apij2/admin-api/voucher/achievement-appraise/updateStatus`, obj)
        .then(res => {
          if (res.code == 0 && res.data) {
            this.dialogOpinionVisible = false;
            this.auditMaterialDialog = false;
            if (this.auditType === 5) {
              this.$message.success('审核通过！');
              this.activeStep = 3;
              this.nextEvent();
            } else {
              this.$message.success('成功退回！');
              this.checkAchievementStatus();
            }
          }
        });
    },
    //导出
    exportOut() {
      let url = '';
      if (this.times) {
        url =
          window.urlConfig.url +
          'Technology_Gain_Evaluate?time_type=1&start_datetime=' +
          this.times[0] +
          '&end_datetime=' +
          this.times[1];
      } else {
        url = window.urlConfig.url + 'Technology_Gain_Evaluate';
      }
      var a = document.createElement('a');
      a.href = url;
      a.download = '';
      a.click();
      this.visible = false;
      this.times = null;
    },
    search() {
      this.url = `${urlConfig.devUrl}apij2/admin-api/voucher/achievement-appraise/page`;
      this.tableParams = {
        userId: JSON.parse(Cookies.get('userInfo')).id,
        status: this.statusVal,
        achievementName: this.searchValue
      };
      if (this.srelease === 2) {
        this.tableParams.isMarket = this.isMarket;
      } else if (this.srelease === 3) {
        this.tableParams.isAchievement = this.isAchievement;
      } else if (this.srelease === 1) {
        this.tableParams.isMarket = 1;
        this.tableParams.isAchievement = 1;
      } else {
        delete this.tableParams.isMarket;
        delete this.tableParams.isAchievement;
      }
    },
    close() {
      this.$refs.children.getData(this.url);
    },
    // 查看
    checkEvent(row) {
      console.log(123);
      this.dialogCheck = true;
      this.form = Object.assign({}, row);
    },
    editEvent(row) {
      this.status = row.status;
      this.applicationRecordId = row.applicationRecordId;
      console.log(row);
      switch (row.status) {
        case 0:
          this.activeStep = 0;
          break;
        case 1:
          this.activeStep = 1;
          break;
        case 2:
        case 4:
        case 6:
          this.activeStep = 2;
          break;
        case 5:
          this.activeStep = 3;
          break;
        case 7:
        case 8:
          this.activeStep = 4;
          break;
        case 9:
          this.activeStep = 5;
          break;
      }
      this.id = row.id;

      if (this.activeStep === 2) {
        this.checkAchievementStatus();
      } else {
        this.dialogFormVisible = true;
      }

      // this.one = row.status >= 1 ? 1 :0;
      // this.commissionContractSrc = JSON.parse(row.commissionContractSrc) || [];
      // this.three = row.status >= 7 ? 7 : 6;
      // this.specialistReviewSrc = JSON.parse(row.specialistReviewSrc) || [];
      // this.examinationResultsSrc = JSON.parse(row.examinationResultsSrc) || [];
      //}
    },

    // 校验原始材料是否上传
    checkAchievementStatus() {
      this.http
        .get(
          `${urlConfig.devUrl}apij2/admin-api/voucher/achievement-appraise-raw-materials/checkAchievementStatus?achievementAppraiseId=${this.id}`
        )
        .then(res => {
          if (res.code == 0) {
            this.verify = res.data;
            if (res.data) {
              console.log('111', this.verify);
              this.dialogFormVisible = true;
            } else {
              return this.$message.warning('等待申请方提交资料，暂时不能操作');
            }
          } else {
            return;
          }
        });
    },

    verifyChange() {
      console.log(this.verify);
      this.checkAchievementStatus();
    },

    nextEvent() {
      let obj = {
        id: this.id
      };
      if (this.activeStep == 0) {
        obj.status = 1;
      }
      if (this.activeStep == 1) {
        // 签订委托合同、
        if (this.commissionContractSrc.length == 0) {
          this.$message.error('请上传委托合同');
          return;
        }
        let arr = [];
        if (this.commissionContractSrc.length > 0) {
          this.commissionContractSrc.map(item => {
            arr.push({
              url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
              name: item.name
            });
          });
          obj.commissionContractSrc = JSON.stringify(arr);
        } else {
          obj.commissionContractSrc = '';
        }

        obj.status = 2;
      }
      if (this.activeStep == 2) {
        if (!this.verify) {
          this.$message.warning('请选择审核状态');
          return;
        } else {
          this.checkAchievementStatus();
          console.log('this.verify??', this.verify);
          if (this.verify) {
            console.log('审核');
            this.auditMaterialDialog = true;
            return;
          }
        }
      }
      if (this.activeStep == 3) {
        // 专家评审
        if (this.specialistReviewSrc.length == 0) {
          this.$message.warning('请上传附件材料');
          return;
        }

        let arr = [];
        if (this.specialistReviewSrc.length > 0) {
          this.specialistReviewSrc.map(item => {
            arr.push({
              url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
              name: item.name
            });
          });
          obj.specialistReviewSrc = JSON.stringify(arr);
        } else {
          obj.specialistReviewSrc = '';
        }

        obj.status = 8;
      }
      if (this.activeStep == 4) {
        // if (this.three == 6) {
        // 	this.$message.error('审核未通过 暂不能进行下一步')
        // 	return
        // }
        if (this.examinationResultsSrc.length == 0) {
          this.$message.error('请上传评价报告');
          return;
        }
        let arr = [];
        if (this.examinationResultsSrc.length > 0) {
          this.examinationResultsSrc.map(item => {
            arr.push({
              url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
              name: item.name
            });
          });
          obj.examinationResultsSrc = JSON.stringify(arr);
        } else {
          obj.examinationResultsSrc = '';
        }

        obj.status = 9;
      }

      this.postData(obj);
    },
    postData(data) {
      this.http
        .put(`${urlConfig.devUrl}apij2/admin-api/voucher/achievement-appraise/updateStatus`, data)
        .then(res => {
          if (res.code == 0) {
            this.activeStep++;
            // if (this.activeStep >= 5) {
            // 	this.activeStep = 4;
            // 	this.dialogFormVisible = false
            // 	this.$refs.children.getData(this.url);
            // }
            if (this.activeStep === 2) {
              this.checkAchievementStatus();
            }
            this.search();
          } else {
            this.$message.error('提交 请重新提交');
          }
        });
    },
    handleDownLoad() {
      this.http
        .get(
          `${urlConfig.devUrl}apij2/home-api/trade/application-record/get?id=${this.applicationRecordId}`
        )
        .then(res => {
          if (res.code == 0) {
            console.log(res.data);
						const val = res.data;
            const _that = this;
            JSZipUtils.getBinaryContent('template.docx', function(error, content) {
              if (error) {
                throw error;
              }
              let zip = new PizZip(content);
              let doc = new docxtemplater();
              doc.loadZip(zip);
              var obj = _that.getReportTemplate(val.fullReport, val.startTime);
              doc.setData(obj);
              try {
                doc.render();
              } catch (error) {
                let e = {
                  message: error.message,
                  name: error.name,
                  stack: error.stack,
                  properties: error.properties
                };
                console.log(JSON.stringify({ error: e }));
                throw error;
              }
              let out = doc.getZip().generate({
                type: 'blob',
                mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
              });
              saveAs(out, '科技成果标准化评价报告.docx');
            });
          }
        });
    },
    getReportTemplate(val, time) {
      const list = val.split('\n');
      console.log('list', list);
      if (list.length <= 0) return;
      const first = list.findIndex(item => item.indexOf('第一部分：科技成果概述') > -1);
      const second = list.findIndex(item => item.indexOf('第二部分：技术成熟度评价') > -1);
      const third = list.findIndex(item => item.indexOf('第三部分：技术创新度评价') > -1);
      const fourth = list.findIndex(item => item.indexOf('第四部分：技术先进度评价') > -1);
      const fifth = list.findIndex(item => item.indexOf('第五部分：效益分析') > -1);
      const sixth = list.findIndex(item => item.indexOf('第六部分：团队评价') > -1);
      const namesixth = list.findIndex(item => item.indexOf('科技成果完成人员名单') > -1);

      const content = list.slice(11, first);
      const contentStr = content.join('');

      const firstList = list.slice(first + 1, second);
      const fisrtStr = firstList.join('');

      const secondList = list.slice(second + 1, third);
      const secondStr = secondList.join('');

      const thirdList = list.slice(third + 1, fourth);
      const thirdStr = thirdList.join('');

      const fourthList = list.slice(fourth + 1, fifth);

      const fifthList = list.slice(fifth + 1, sixth);
      var sixthList, sixthStr, tableData;

      if (namesixth === -1) {
        sixthList = list.slice(sixth + 1);
        sixthStr = sixthList.join('');
      } else {
        sixthList = list.slice(sixth + 1, namesixth);
        sixthStr = sixthList.join('');
        tableData = list.slice(namesixth + 1).map(el => {
          var lis = el.split(' ');
          return {
            column1: lis[0],
            column2: lis[1],
            column3: lis[2],
            column4: lis[3],
            column5: lis[4],
            column6: lis[5],
            column7: lis[6],
            column8: lis[7]
          };
        });
      }
      console.log('contentStr', contentStr);
      const model = {
        a: list[1].slice(8, list[1].length),
        b: list[2].slice(7, list[2].length),
        c: list[3].slice(7, list[3].length),
        d: list[4].slice(8, list[4].length),
        achievementType: list[5].slice(5, list[5].length),
        contactName: list[6].slice(4, list[6].length),
        contactInformation: list[7].slice(5, list[7].length),
        startDate: list[8].slice(5, list[8].length),
        completionDate: list[9].slice(5, list[9].length),
        achievementProfiles: list[10].slice(5, list[10].length),
        tableData: tableData,
        e: contentStr,
        f: fisrtStr,
        g: secondStr,
        h: thirdStr,
        i_1: fourthList[0],
        i_2: fourthList[1],
        j_1: fifthList[1],
        j_2: fifthList[3],
        k: sixthStr,
        time: dateformat.format(new Date(time), 'yyyy年 MM月 dd日'),
        year: dateformat.yearToChineseCapital(new Date(time)) + '年'
      };
      return model;
    },
    preEvent() {
      this.dialogFormVisible = false;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!');
      }
      return isLt2M;
    },
    beforeAvatarUploadLimit(file) {
      if (this.examinationResultsSrc.length === 1) {
        return this.$message.warning('您已经上传了一份报告，请删除后重新上传');
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!');
      }
      return isLt2M;
    },
    handleRemove(file, fileList, type) {
      this[type] = fileList;
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this[type] = fileList;
      }
    },
    detailClose() {
      this.dialogCheck = false;
    },
    auditClose(flag) {
      console.log('flag', flag);
      this.auditMaterialDialog = false;
      if (flag) {
        this.nextEvent();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@include component(business-evaluation) {
  width: 100%;

  // padding: 30px;
  @include part(header) {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;

    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }

  @include part(step) {
    width: 100%;
    margin: 0 auto;
  }

  @include part(dialog) {
    padding: 30px 50px;
  }

  /deep/.evaluation_dialog {
    border-radius: 6px;
    .el-dialog__header {
      border-radius: 6px 6px 0 0;
      background: #fff !important;
      .header-title {
        position: relative;
        height: 100%;
        line-height: 50px;
        text-align: left;
        padding: 0 0 0 26px;
        font-weight: 600;
        font-size: 16px;

        &::before {
          content: '';
          position: absolute;
          width: 10px;
          height: 20px;
          background-color: #428dff;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
    }

    .el-dialog__body {
      .evaluation_dialog_top {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .satisfaction {
          font-size: 28px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #333333;
          line-height: 48px;
          text-align: center;
        }
        .el-rate {
          margin-top: 14px;
          i {
            font-size: 32px;
            margin-right: 18px;
          }
        }
      }
      .evaluation_dialog_content {
        margin-top: 46px;
        .content {
          margin-top: 10px;
          textarea {
            min-height: 100px !important;
          }
        }
      }
    }
  }
  .el-dialog__header {
    border-radius: 6px 6px 0 0;
    background: #fff !important;
    padding: 1px 0 0 0;
    .header-title {
      display: flex;
      width: 100%;
      position: relative;
      height: 100%;
      line-height: 50px;
      text-align: left;
      padding: 0 0 0 26px;
      font-weight: 600;
      font-size: 16px;
      justify-content: space-between;

      &::before {
        content: '';
        position: absolute;
        width: 10px;
        height: 20px;
        background-color: #428dff;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
      }
      i {
        cursor: pointer;
        margin-right: 10px;
      }
    }
  }
}
</style>
